import React from 'react'
import Image from 'next/image'
import PropTypes from 'prop-types'
import { Text } from '@paper-monster/web/src/components/common'

import BuyNowCta from '@/components/BuyNowCta'
import TryFreeCta from '@/components/TryFreeCta'

import styles from './Hero.module.scss'

export default function Hero({ t }) {
  return (
    <section className={styles.hero}>
      <div className={styles.gridBg} />

      {/* Decorative rectangles - left side */}
      <div className={styles.decoLeft}>
        <div className={styles.decoRect} />
        <div className={styles.decoRect} />
        <div className={styles.decoRect} />
      </div>

      {/* Decorative rectangles - right side */}
      <div className={styles.decoRight}>
        <div className={styles.decoRect} />
        <div className={styles.decoRect} />
        <div className={styles.decoRect} />
      </div>

      <div className={styles.inner}>
        <div className={styles.copy}>
          <Text className={styles.price} onTint>{t.price}</Text>

          {/* Headline */}
          <Text.H1 className={styles.title}>
            {t.titleLines.map((line) => (
              <span key={line} className={styles.titleLine}>{line} </span>
            ))}
          </Text.H1>

          {/* Subtitle */}
          <Text.P className={styles.subtitle}>{t.subtitle}</Text.P>

          {/* CTA Buttons */}
          <div className={styles.ctaRow}>
            <TryFreeCta buttonMessageId={null} className={styles.ctaPrimary} size="xlTall">{t.ctaPrimary}</TryFreeCta>
            <BuyNowCta className={styles.ctaSecondary} messageId={null} size="xlTall" variant="secondary">{t.ctaSecondary}</BuyNowCta>
          </div>

          <div className={styles.checks}>
            {t.checks.map((check) => (
              <span key={check} className={styles.check}>
                <Image alt="" height={18} src="/check-icon.svg" width={18} />
                <Text className={styles.checkText}>{check}</Text>
              </span>
            ))}
          </div>
        </div>

        {/* Hero image */}
        <div className={styles.imageWrapper}>
          <Image
            alt={t.imageAlt}
            className={styles.heroImage}
            height={704}
            priority
            src="/small-business-file-grid-v2.webp"
            width={1244}
          />
        </div>
      </div>
    </section>
  )
}

Hero.propTypes = {
  t: PropTypes.shape({
    price: PropTypes.string.isRequired,
    titleLines: PropTypes.arrayOf(PropTypes.string).isRequired,
    subtitle: PropTypes.string.isRequired,
    ctaPrimary: PropTypes.string.isRequired,
    ctaSecondary: PropTypes.string.isRequired,
    checks: PropTypes.arrayOf(PropTypes.string).isRequired,
    imageAlt: PropTypes.string.isRequired,
  }).isRequired,
}
